

import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';


const GalaCreator = () => {
  const { t } = useTranslation();
  return (
    <div>
    <Typography variant="h4" gutterBottom>{t('gala')}</Typography>
    </div>
  );
};

export default GalaCreator;